import { Tooltip } from "primereact/tooltip";

interface IIconMode {
  name:string
  type: string;
  color: string;
  fontSize: string;
}

export const IconMode = ({name,type,color,fontSize}:IIconMode) => {
  return (
    <>
    <Tooltip target=".tooltipMode" />
      <i
        className={`pi pi-${type} tooltipMode`}
        data-pr-tooltip={name}
        data-pr-position="right"
        style={{
          backgroundColor: `${color}`,
          color: "#FFFFFF",
          padding: "0.2rem",
          fontSize: fontSize,
        }}
      >
        {" "}
      </i>
    </>
  );
};
